import styled from 'styled-components';

export const SubscriptionFullPaymentInfoStyles = styled.div`
  color: var(--text-color-black);
  flex: 1;

  &.soldOut {
    color: #3c3c4399;
  }

  .plan-duration-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .duration-text {
    color: inherit;
    font-weight: 600;
  }

  .billing-info {
    color: inherit;
    opacity: 0.8;
  }
`;

export const SubscriptionPerDayPaymentInfoStyles = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: var(--text-color-black);

  &.soldOut {
    color: #3c3c4399;
  }

  .plan-price-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }

  .price-text {
    color: inherit;
    font-weight: 700;
  }

  .price-info {
    color: inherit;
    opacity: 0.8;
  }
`;
